
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Gamepad2, Home, Search, TrendingUp } from 'lucide-react';

const GameNotFound = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50 px-4">
    <Card className="max-w-lg w-full text-center shadow-xl">
      <CardContent className="pt-8 pb-6">
        {/* Game Icon */}
        <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-red-100 to-pink-100 rounded-full flex items-center justify-center">
          <Gamepad2 className="w-10 h-10 text-red-600" />
        </div>

        {/* Error Message */}
        <CardTitle className="text-2xl font-bold text-gray-800 mb-3">
          Game Not Found
        </CardTitle>
        <p className="text-gray-600 mb-8 leading-relaxed">
          The game you're looking for doesn't exist or has been removed. It might have been moved to a different category or is no longer available.
        </p>

        {/* Action Buttons */}
        <div className="space-y-3">
          <Button asChild size="lg" className="w-full">
            <Link to="/" className="flex items-center justify-center gap-2">
              <Home className="w-4 h-4" />
              Browse All Games
            </Link>
          </Button>
          
          <div className="grid grid-cols-2 gap-2">
            <Button asChild variant="outline" size="sm">
              <Link to="/trending" className="flex items-center justify-center gap-2">
                <TrendingUp className="w-4 h-4" />
                Trending
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="sm">
              <Link to="/search" className="flex items-center justify-center gap-2">
                <Search className="w-4 h-4" />
                Search
              </Link>
            </Button>
          </div>
        </div>

        {/* Help Text */}
        <div className="mt-6 pt-4 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            Try browsing our{' '}
            <Link to="/categories" className="text-blue-600 hover:underline">
              game categories
            </Link>{' '}
            or check out our{' '}
            <Link to="/new" className="text-blue-600 hover:underline">
              newest games
            </Link>
          </p>
        </div>
      </CardContent>
    </Card>
  </div>
);

export default GameNotFound;
